import { autoinject, bindable } from 'aurelia-framework';
import { SideBar, ISideBarContainer } from './side-bar';

@autoinject
export class SideBarContainer implements ISideBarContainer {
	@bindable key = 'side-bar-1';
	visible = false;

	constructor(private sideBar: SideBar) {
	}

	attached() {
		this.sideBar.addContainer(this);
	}

	close() {
		this.visible = false;
	}
}
